import { render, staticRenderFns } from "./VLargeBarChar.vue?vue&type=template&id=72c6f971&scoped=true"
import script from "./VLargeBarChar.vue?vue&type=script&lang=js"
export * from "./VLargeBarChar.vue?vue&type=script&lang=js"
import style0 from "./VLargeBarChar.vue?vue&type=style&index=0&id=72c6f971&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c6f971",
  null
  
)

export default component.exports